import "./VillageVoucherInformation.css";
import {Products} from "../../../utils";
import {useTranslation} from "react-i18next";

const VillageVoucherInformationComponent = ({userData, periodEndDate}) =>{
    const VILLAGE_ELLIGIBLE_PRODUCTS = Object.freeze([Products.VILLAGE, Products.ULTIMATE])

    const {t} = useTranslation();


    return (<>
        {(userData?.vouchers?.filter(voucher => voucher?.provider === "VILLAGE")?.length &&
            VILLAGE_ELLIGIBLE_PRODUCTS.some(product => userData?.subscription?.product?.name.startsWith(product))) ?
            <div className={"subscriptionInformation-village"}>
                <div className={"subscriptionInformation-village-header"}>
                    <span>{t("accountVoucherTitle")}</span>
                    <img src={"images/VILLAGE CINEMAS_LOGO Color White 2 - big.png"} alt={"village logo"}/>
                </div>
                <div className={"subscriptionInformation-village-content"}>
                    <div className={"subscriptionInformation-village-voucher"} onClick={() => {
                        if (window.isSecureContext)
                            navigator.clipboard.writeText(userData?.vouchers?.find(voucher => voucher?.provider === "VILLAGE").value);
                    }}>
                        <span>{userData?.vouchers?.find(voucher => voucher?.provider === "VILLAGE").value}</span>
                        <img src={"images/account/copyIcon.svg"} alt={"click to copy on clipboard"}/>
                    </div>
                    <div className={"subscriptionInformation-village-field"}>
                                          <span
                                              className={"subscriptionInformation-village-field-title"}>{t("accountVoucherAvailableUntil")} </span>
                        <span
                            className={"subscriptionInformation-village-field-data"}>{periodEndDate}</span>
                    </div>
                </div>
                <span className={"subscriptionInformation-village-description"}>
                    {t("accountVoucherDescription")}
                </span>
            </div>
            : <></>
        }
    </>)
}

export default VillageVoucherInformationComponent;